import { useMemo } from 'react';

import adminConsumableService from '@services/admin/consumableService';

/**
 * Admin Consumable Service Hook
 *
 * 提供 Admin 角色的 Consumable 服務方法
 */
export default function useAdminConsumableService() {
  return useMemo(() => ({
    get: adminConsumableService.get,
    create: adminConsumableService.create,
    update: adminConsumableService.update,
    checkBarcode: adminConsumableService.checkBarcode,
  }), []);
}
